
export const ICONS = {
  P2E: 'https://files.peakd.com/file/peakd-hive/crypto-shots/23yU27btsv43YaxZHjwK7X1ZCqbA446BT25E6esXLEESQg2NhWXn8nmyoFQGoMqrHRGb3.png',
  F2P: 'https://files.peakd.com/file/peakd-hive/crypto-shots/23ydPCmfLTvNSPxZnVYqyxyr1pMfE4QCEeGs4j9rQzLTr2YNSZm5Yo2burv71MhGTv4GP.png',
  CONTROLLER: 'https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-413-game-controller@2x.png',
};
